import CLanguageHandler, { getLanguageFromHTML } from '../Languages/LanguageHandler'
import { IsStringEmpty } from '../utils/GlobalFunctions'
import { Page } from '../constants/Components/Page'

const DEFAULT_LANGUAGE: string = 'en_GB'

let webLinksCustom: string = ''

export const getWebLinksCustom = (): string => webLinksCustom

// Function wait for the DOM to be loaded before executing the code.
// This is to make sure the language is set before the page is rendered.
const waitForDOMAndGetLanguage = (): Promise<string> =>
    new Promise<string>((resolve): void => {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', (): void =>
                resolve(getLanguageFromHTML() ?? DEFAULT_LANGUAGE)
            )
        } else {
            resolve(getLanguageFromHTML() ?? DEFAULT_LANGUAGE)
        }
    })

// eslint-disabled
;((): void => {
    waitForDOMAndGetLanguage().then((languageFromHTML: string): void =>
        CLanguageHandler.getInstance().setLanguage(languageFromHTML)
    )

    webLinksCustom =
        (document.querySelector('input[data-akixi-web-links-custom]') as HTMLInputElement)?.dataset
            ?.akixiWebLinksCustom ?? ''
})()
// eslint-enabled

let nonce: string = ''

export const getNonce = (): string => {
    if (IsStringEmpty(nonce)) {
        nonce = (document.querySelector('input[data-akixi-nonce]') as HTMLInputElement)?.dataset?.akixiNonce ?? ''
    }

    return nonce
}

// Find the hidden page detection element without react context as this is the top level component
// until the reporting portal will be rewritten to react component as well.
let pageName: Page

export const getPageName = (): Page => {
    if (IsStringEmpty(pageName)) {
        pageName = (document.querySelector('input[data-page]') as HTMLInputElement)?.dataset?.page as Page
    }

    return pageName
}
